// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Utilities
import { populatePath, translateDate } from 'common/utils/helpers';

// Enums
import { EngagementReportType } from 'engagementReport/enums/propTypes';
import ProjectStatus from 'project/enums/ProjectStatus';

// Routes
import Routes from 'routes';

const EngagementReportHero = ({ engagementReport, projectStatus, projectHubEnabled }) => {
  const params = useParams();
  const { t } = useTranslation();
  const { engagement } = engagementReport.snapshot;
  const { project } = engagement;
  const showProjectHubLink =
    projectHubEnabled &&
    (projectStatus === ProjectStatus.ACTIVE || projectStatus === ProjectStatus.FINISHED);
  const { excludeMissingFingerprints, completedSubmissions, excludeDuplicates } =
    engagement.filters;
  const filtered = excludeDuplicates || excludeMissingFingerprints || completedSubmissions;
  const asterisk = filtered ? '*' : '';
  const participantsText = `${engagement.respondedSubmissionsCount} ${t(
    'engagement_report.participants'
  )} ${asterisk}`;

  return (
    <div className="engagement-report-hero">
      <div className="container inner">
        <div className="columns">
          <div className="column engagement-report-hero__meta">
            <h2 className="title is-5 is-primary-color">{t('engagement_report.title')}</h2>
            <div>
              {`${t('engagement_report.created')}: ${translateDate(engagementReport.createdAt, t)}`}
            </div>
          </div>
          <div className="column engagement-report-hero__meta engagement-report-hero__meta--project">
            <h2 className="title is-5 is-primary-color">{project.title}</h2>
            {showProjectHubLink && (
              <div>
                <a
                  href={populatePath(Routes.PROJECT, params)}
                  className="is-secondary-color engagement-report-hero__meta-link"
                >
                  {t('engagement.visit_project_hub')}
                </a>
              </div>
            )}
          </div>
        </div>
        <h1 className="title is-2 is-primary-color engagement-report-hero__title">
          {engagement.title}
        </h1>
        <div className="engagement-report-hero__meta engagement-report-hero__meta--engagement">
          <div>
            {`${translateDate(engagement.startTime, t)} - ${translateDate(engagement.endTime, t)}`}
          </div>
          <div>{participantsText}</div>
        </div>
      </div>
    </div>
  );
};

EngagementReportHero.propTypes = {
  engagementReport: EngagementReportType.isRequired,
  projectStatus: PropTypes.string,
  projectHubEnabled: PropTypes.bool.isRequired,
};

EngagementReportHero.defaultProps = {
  projectStatus: '',
};

export default EngagementReportHero;
